import { Component, OnInit, ChangeDetectionStrategy, ElementRef, ViewChild, Input } from '@angular/core';
import { ApiService } from '@services/api.service';

const canvasWrapper = 'canvasWrapper';
const contentNode = 'content';

@Component({
  selector: 'bar-code',
  template: `<div class="h" #${contentNode}><ng-content></ng-content></div><div class="w" #${canvasWrapper}></div>`,
  styles: [`.h { display: none; }`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BarcodeComponent implements OnInit {

	private _currentlyEncodedValue!: string;

	@ViewChild(contentNode, {read: ElementRef, static: true}) contentRef: ElementRef<HTMLElement>;

	@ViewChild(canvasWrapper, {read: ElementRef, static: true}) targetRef: ElementRef<HTMLElement>;

	@Input() set config(cfg) {
		this._cfg = cfg;
		this._render(this._currentlyEncodedValue);
	};
	get config() { return this._cfg }
	private _cfg: JsBarcode.Options;

	constructor(
		private _api: ApiService,
	) { }

	ngOnInit(): void {
	}

	ngAfterContentChecked() {
		const cur = this._currentlyEncodedValue;
		const inc = this.contentRef.nativeElement?.innerText;
		if (cur !== inc) {
			this._render(inc);
		}
	}


	private _render(value: string) {
		const t = this.targetRef.nativeElement;
		t.innerHTML = '';
		console.log('config', this.config);
		if (value) {
			this.targetRef.nativeElement.appendChild(
				this._api.barcode.toCanvas(value, this.config)
			);
			this._currentlyEncodedValue = value;
		}
	}
}
